import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';

declare const __BASE_PATH__: string;

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Navbar />
      <AppRoutes />
      <Footer />
      <WhatsAppButton />
    </BrowserRouter>
  );
}

export default App;
